export function isAwaitingDomainAccess(
    canViewAllDomains: boolean,
    domains?: { id: number }[] | null,
): boolean {
    if (canViewAllDomains) return false
    return !domains || domains.length === 0
}
